import React, { useContext, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { UserContext, SnackbarContext, ContentContext } from '../../contexts';
import API from '../../api';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

export const MainHeader = (props) => {
  const history = useHistory();
  const { updateSnackbar } = useContext(SnackbarContext);
  const [hoverItem, setHoverItem] = useState(null);
  const { userInfo, clearToken } = useContext(UserContext);
  const { deviceWidth } = useContext(ContentContext);
  const [userMenu, setUserMenu] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);

  let CLEAR_FUNC = null;

  const LEFT_LIST = [
    {
      text: '팝플이란',
      activePath: 'intro',
      url: '/intro',
    },
    {
      text: '마켓플레이스',
      activePath: 'marketplace',
      url: '/marketplace/list',
    },
    {
      text: 'Contributors',
      activePath: 'contributors',
      url: '/contributors/list',
    },
  ];

  const [open, setOpen] = useState(false);

  //hooks

  useEffect(() => {
    if (userInfo) {
      if (userInfo.userType === 'Personal') {
        setUserMenu([
          {
            type: 'viewer',
            text: userInfo.name + ' 님',
          },
          {
            type: 'action',
            text: '로그아웃',
            action: () => {
              clearToken();
            },
          },
          {
            type: 'sub',
            text: '마이페이지',
            activePath: 'mypage',
            child: [
              {
                text: '구매 목록',
                path: '/mypage/purchase_list',
              },
              {
                text: '선도 구매 목록',
                path: '/mypage/forward_purchase_list',
              },
              {
                text: '투자/출금',
                path: '/mypage/calculate',
              },
              {
                text: '회원 정보 수정',
                path: '/mypage/modify',
              },
            ],
          },
          {
            type: 'sub',
            text: '고객센터',
            activePath: 'cs',
            child: [
              {
                text: '공지사항',
                path: '/cs/notice',
              },
              {
                text: 'FAQ',
                path: '/cs/faq',
              },
              {
                text: 'Contact us',
                path: '/cs/contact_us',
              },
            ],
          },
        ]);
      } else {
        setUserMenu([
          {
            type: 'viewer',
            text: userInfo.name + ' 님',
          },
          {
            type: 'action',
            text: '로그아웃',
            action: () => {
              clearToken();
            },
          },
          {
            type: 'sub',
            text: '마이페이지',
            activePath: 'mypage',
            child: [
              {
                text: '구매 목록',
                path: '/mypage/purchase_list',
              },
              {
                text: '선도 구매 목록',
                path: '/mypage/forward_purchase_list',
              },
              {
                text: '판매 목록',
                path: '/mypage/sell_list',
              },
              {
                text: '정산/출금',
                path: '/mypage/calculate',
              },
              {
                text: '회원 정보 수정',
                path: '/mypage/modify',
              },
            ],
          },
          {
            type: 'sub',
            text: '고객센터',
            activePath: 'cs',
            child: [
              {
                text: '공지사항',
                path: '/cs/notice',
              },
              {
                text: 'FAQ',
                path: '/cs/faq',
              },
              {
                text: 'Contact us',
                path: '/cs/contact_us',
              },
            ],
          },
        ]);
      }
    } else {
      setUserMenu([
        {
          type: 'link',
          text: '로그인',
          path: '/user/login',
        },
        {
          type: 'link',
          text: '회원가입',
          path: '/user/signup_guide',
        },
        {
          type: 'sub',
          text: '고객센터',
          activePath: 'cs',
          child: [
            {
              text: '공지사항',
              path: '/cs/notice',
            },
            {
              text: 'FAQ',
              path: '/cs/faq',
            },
            {
              text: 'Contact us',
              path: '/cs/contact_us',
            },
          ],
        },
      ]);
    }
  }, [userInfo]);

  // event
  const onMouseEnterHandler = (item) => {
    if (CLEAR_FUNC) {
      clearTimeout(CLEAR_FUNC);
    }
    setHoverItem(item);
  };

  const onMouseLeaveHandler = () => {
    CLEAR_FUNC = setTimeout(() => {
      setHoverItem(null);
    }, [1000]);
  };

  const renderChildNavClassname = (type, index, child_index) => {
    let return_classname = '';

    if (type === 'left') {
      let target_child_item = LEFT_LIST[index].child[child_index];

      // console.log('target_child_item', target_child_item);
      // console.log('history.location.pathname', history.location.pathname);
      let targetRegexp = new RegExp(history.location.pathname, 'i');
      const isValidtion = targetRegexp.test(target_child_item.path);
      if (isValidtion && history.location.pathname !== '/') {
        return_classname += 'active';
      }
    } else if (type === 'right') {
      let target_child_item = userMenu[index].child[child_index];
      let targetRegexp = new RegExp(history.location.pathname, 'i');
      const isValidtion = targetRegexp.test(target_child_item.path);
      if (isValidtion && history.location.pathname !== '/') {
        return_classname += 'active';
      }
    }

    console.log('return_classname', return_classname);
    return return_classname;
  };

  const renderSubMenu = () => {
    if (hoverItem) {
      const { type, index } = hoverItem;
      switch (type) {
        case 'left': {
          return (
            <>
              {LEFT_LIST[index].child.map((item, child_index) => {
                return (
                  <li
                    className={renderChildNavClassname('left', index, child_index)}
                    onClick={() => {
                      if (item.type && item.type === 'action') {
                        switch (item.action) {
                          case 'NEW_PROJECT': {
                            console.log('NEW_PROJECT');
                            API.Project.PostNew().then(
                              (res) => {
                                let result = res.data;
                                console.log('Project PostNew result', result);
                                history.push('/project/writing/' + result.project.seq);
                              },
                              (err) => {
                                updateSnackbar({
                                  type: 'error',
                                  open: true,
                                  message: err.data.message,
                                });
                              },
                            );
                            break;
                          }
                          case 'REQUEST_REDUCTION': {
                            console.log('action');
                            setOpen(true);
                            break;
                          }

                          default: {
                            console.log('action none');
                          }
                        }
                      } else {
                        history.push(item.path);
                      }
                    }}
                  >
                    <span>{item.text}</span>
                  </li>
                );
              })}
            </>
          );
        }
        case 'right': {
          return (
            <>
              {userMenu[index].child.map((item, child_index) => {
                return (
                  <li
                    className={renderChildNavClassname('right', index, child_index)}
                    onClick={() => {
                      history.push(item.path);
                    }}
                  >
                    <span>{item.text}</span>
                  </li>
                );
              })}
            </>
          );
        }
        default: {
          return null;
        }
      }
    } else {
      return null;
    }
  };

  const renderNavClassname = (type, index) => {
    // console.log('renderNavClassname', type);
    let return_classname = '';
    let pathArray = history.location.pathname.split('/');
    let parentPath = pathArray[1];

    if (hoverItem) {
      if (type === hoverItem.type && hoverItem.index === index) {
        return_classname += ' on';
      }
    }

    if (type === 'left') {
      if (parentPath === LEFT_LIST[index].activePath) {
        return_classname += ' active';
      }
    } else {
      // console.log('parentPath', parentPath);
      if (parentPath === userMenu[index].activePath) {
        return_classname += ' active';
      }
    }

    return return_classname;
  };

  const renderSubNavClassname = () => {
    if (hoverItem) {
      return 'sub-menu__container open';
    } else {
      return 'sub-menu__container';
    }
  };

  const renderLogoIco = () => {
    if (history.location.pathname === '/') {
      return 'ico logo';
    } else {
      return 'ico logo';
    }
  };

  return (
    <article className='main-header'>
      <section className='menu__container'>
        <article className='content__wrapper'>
          <section className='left__container'>
            <section className='logo__box'>
              <div
                className={renderLogoIco()}
                onClick={() => {
                  history.push('/');
                }}
              ></div>
            </section>
            <section className='nav__box'>
              <ul>
                {LEFT_LIST.map((item, index) => {
                  return (
                    <li
                      onClick={() => {
                        console.log('work');
                        history.push(item.url);
                      }}
                      className={renderNavClassname('left', index)}
                    >
                      <span>{item.text}</span>
                    </li>
                  );
                })}
              </ul>
            </section>
          </section>
          <section className='right__container'>
            <ul>
              {userMenu &&
                userMenu.map((item, index) => {
                  const { type, text, path, action } = item;
                  switch (type) {
                    case 'sub': {
                      return (
                        <li
                          onMouseEnter={(e) => {
                            onMouseEnterHandler({
                              index: index,
                              type: 'right',
                            });
                          }}
                          onMouseLeave={(e) => {
                            onMouseLeaveHandler();
                          }}
                          className={renderNavClassname('right', index)}
                        >
                          <span>{text}</span>
                        </li>
                      );
                    }
                    case 'link': {
                      return (
                        <li
                          onClick={() => {
                            history.push(path);
                          }}
                        >
                          <span>{text}</span>
                        </li>
                      );
                    }
                    case 'action': {
                      return (
                        <li
                          onClick={() => {
                            action();
                          }}
                        >
                          <span>{text}</span>
                        </li>
                      );
                    }
                    default: {
                      return (
                        <li>
                          <span>{text}</span>
                        </li>
                      );
                    }
                  }
                })}
            </ul>
            <div className='menu__box'>
              <div
                className='ico header-menu'
                onClick={() => {
                  setMenuOpen(true);
                }}
              ></div>
            </div>
            <div className={menuOpen ? 'menu-list__box open' : 'menu-list__box'}>
              <header>
                <div className='logo__box'>
                  <div className='ico logo-small'></div>
                </div>
                <div className='close__box'>
                  <div
                    className='ico close'
                    onClick={() => {
                      setMenuOpen(false);
                    }}
                  ></div>
                </div>
              </header>
              <div className={userInfo ? 'mobile-list__box user' : 'mobile-list__box'}>
                {LEFT_LIST.map((item, index) => {
                  return (
                    <div
                      className='mobile-list__item'
                      onClick={() => {
                        history.push(item.url);
                      }}
                    >
                      <h3>{item.text}</h3>
                    </div>
                  );
                })}
                {userMenu &&
                  userMenu.map((item, index) => {
                    if (item.type === 'sub') {
                      return (
                        <div
                          className={
                            userMenu.length === index + 1 ? 'mobile-accordion__item last' : 'mobile-accordion__item'
                          }
                        >
                          <Accordion>
                            <AccordionSummary expandIcon={<div className='ico arrow-down'></div>}>
                              <h3>{item.text}</h3>
                            </AccordionSummary>
                            <AccordionDetails>
                              {item.child.map((sub_item, sub_index) => {
                                return (
                                  <div
                                    className='mobile-child__item'
                                    onClick={() => {
                                      history.push(sub_item.path);
                                    }}
                                  >
                                    <span>{sub_item.text}</span>
                                  </div>
                                );
                              })}
                            </AccordionDetails>
                          </Accordion>
                        </div>
                      );
                    }
                  })}
              </div>
              {!userInfo && (
                <div className='login__box'>
                  <div
                    className='login'
                    onClick={() => {
                      history.push('/user/login');
                    }}
                  >
                    로그인
                  </div>
                  <div
                    className='signup'
                    onClick={() => {
                      history.push('/user/signup_guide');
                    }}
                  >
                    회원가입
                  </div>
                </div>
              )}
              {userInfo && (
                <div className='logout__box'>
                  <h3
                    onClick={() => {
                      clearToken();
                    }}
                  >
                    로그아웃
                  </h3>
                </div>
              )}
            </div>
          </section>
        </article>
      </section>
      <section
        className={renderSubNavClassname()}
        onMouseEnter={(e) => {
          onMouseEnterHandler(hoverItem);
        }}
        onMouseLeave={(e) => {
          onMouseLeaveHandler();
        }}
      >
        <article className='content__wrapper'>
          <ul className='sub-nav__list'>{renderSubMenu()}</ul>
        </article>
      </section>
    </article>
  );
};
